module.exports = __webpack_public_path__ + "img/cashback-icon.0f45dbd1.svg";